import type { Command } from '@tiptap/core';
import placeCaretBelow from '../../../utils/placeCaretBelow';
import { findParentRow } from './rowUtils';

export const createParagraphBelowRowOnEnter: Command = ({ state, dispatch }) => {
  if (!dispatch) {
    console.error('[createParagraphBelowRowOnEnter] No dispatch function available');
    return false;
  }

  const rowInfo = findParentRow(state, state.selection.$from.pos);
  if (!rowInfo) return false;

  // Only when caret is inside a textblock; ignore NodeSelection (e.g. image)
  if (!state.selection.$from.parent.isTextblock) return false;

  // Right after the row: into the empty paragraph already there, or a new one
  dispatch(placeCaretBelow(state.tr, rowInfo.pos + rowInfo.node.nodeSize));
  return true;
};
